import { cloneDeep, pick } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { getMaterialAssets } from '@/i18n/assets';
import { Cell, CellStyle, LayerType, TextAlignType } from '@/version-types';
import { TablePreset } from '.';
import presetImage from './assets/preset2.png';

const PRESET_ID = '00c84a80';

const getTableByPreset: TablePreset['create'] = () => {
    return {
        id: uuidv4(),
        layerType: LayerType.TABLE,
        width: 868,
        height: 519,
        rotate: 0,
        opacity: 1,
        title: '',
        fitWidth: 0,
        fitHeight: 0,
        materialIds: {},
        extraInfo: {
            lockRatio: false,
        },
        data: {
            presetId: PRESET_ID,
            screenshotUrl: getMaterialAssets().tableLayer.screenshotUrl.table2,
            cells: [
                [
                    {
                        hIndex: 0,
                        vIndex: 0,
                        colSpan: 4,
                        rowSpan: 1,
                        content: '',
                        styleIds: ['2'],
                    },
                    null,
                    null,
                    null,
                ],
                [
                    {
                        hIndex: 0,
                        vIndex: 1,
                        colSpan: 4,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    null,
                    null,
                    null,
                ],
                [
                    {
                        hIndex: 0,
                        vIndex: 2,
                        colSpan: 4,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    null,
                    null,
                    null,
                ],
                [
                    {
                        hIndex: 0,
                        vIndex: 3,
                        colSpan: 4,
                        rowSpan: 1,
                        content: '',
                        styleIds: [],
                    },
                    null,
                    null,
                    null,
                ],
            ],
            baseCells: {
                horizontal: [217, 217, 217, 217],
                vertical: [129.75, 129.75, 129.75, 129.75],
            },
            allStyleId: '1',
            styles: {
                '1': {
                    fontSize: 30,
                    backgroundColor: '#eaecf0ff',
                    bold: true,
                    color: '#000000ff',
                    textAlign: TextAlignType.CENTER,
                    border: {
                        top: {
                            color: '#ffffffff',
                            style: 'line-0',
                            width: 2,
                        },
                        right: {
                            color: '#ffffffff',
                            style: 'line-0',
                            width: 2,
                        },
                        bottom: {
                            color: '#ffffffff',
                            style: 'line-0',
                            width: 2,
                        },
                        left: {
                            color: '#ffffffff',
                            style: 'line-0',
                            width: 2,
                        },
                    },
                },
                '2': {
                    backgroundColor: '#696d7dff',
                },
            },
        },
        lock: false,
        children: [],
        shine: true,
        hidden: false,
    };
};

const tablePreset: TablePreset = {
    id: PRESET_ID,
    preview: presetImage,
    create: getTableByPreset,
    overwriteStyle: (oldTableLayer) => {
        const newTableLayer = cloneDeep(oldTableLayer);

        const headStyleId = `${Math.max(0, ...Object.keys(newTableLayer.data.styles).map(Number)) + 1}`;
        const bodyStyleId = `${+headStyleId + 1}`;
        const cells = newTableLayer.data.cells.flat().filter(Boolean) as Cell[];
        cells.forEach((c) => {
            c.styleIds.push(c.vIndex === 0 ? headStyleId : bodyStyleId);
        });
        const presetDemo = getTableByPreset();
        const bodyStyle: CellStyle = pick(presetDemo.data.styles['1'], ['border', 'backgroundColor']);
        newTableLayer.data.styles[headStyleId] = {
            ...bodyStyle,
            ...pick(presetDemo.data.styles['2'], ['border', 'backgroundColor']),
        };
        newTableLayer.data.styles[bodyStyleId] = bodyStyle;

        return newTableLayer;
    },
};

export default tablePreset;
